import { apiFetch } from "./apiFetch";

// Admin review of therapist self-applications — see docs/consent-and-therapist-registration.md
// ("Admin review" section) for the full request/response contract.

export const fetchTherapistApplications = (
  { status, search, page = 1, limit = 20 } = {}
) => {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (status && status !== "all") params.set("status", status);
  if (search && search.trim()) params.set("search", search.trim());
  return apiFetch(`/admin/therapist-applications?${params}`);
};

export const fetchTherapistApplicationDocumentLink = (id, index) =>
  apiFetch(`/admin/therapist-applications/${id}/documents/${index}/link`);

// reason is only required when re-approving a previously rejected
// application (status: rejected -> approved) - omit it for the plain
// pending -> approved path.
export const approveTherapistApplication = (id, reason) =>
  apiFetch(`/admin/therapist-applications/${id}/approve`, {
    method: "POST",
    ...(reason ? { body: JSON.stringify({ reason }) } : {}),
  });

export const rejectTherapistApplication = (id, reason) =>
  apiFetch(`/admin/therapist-applications/${id}/reject`, {
    method: "POST",
    body: JSON.stringify({ reason }),
  });
